// extracted by mini-css-extract-plugin
module.exports = {"button":"styles_button__VIIEm","label":"styles_label__mM9Pc","icon":"styles_icon__kxh5W"};